import type { IconVariants } from 'core/generic/elements/icons';

export type LocaleSelectorSocialItem = {
	href: string;
	title: string;
	icon: {
		variant: IconVariants;
		alt: string;
	};
};

export type LocaleSelectorItem = {
	href: string;
	lang: string;
	title: string;
	label: string;
	socials: LocaleSelectorSocialItem[];
};

export const LOCALE_SELECTOR_ITEMS: LocaleSelectorItem[] = [
	{
		href: 'https://ar.mancity.com/',
		lang: 'ar',
		title: 'Arabic',
		label: 'العربية',
		socials: [
			{
				href: 'https://twitter.com/cityarabia',
				title: 'x',
				icon: {
					variant: 'BrandX',
					alt: 'x',
				},
			},
		],
	},
	{
		href: 'https://kr.mancity.com',
		lang: 'ko',
		title: 'Korean',
		label: '한국어',
		socials: [
			{
				href: 'https://story.kakao.com/ch/mcfckorea/',
				title: 'kakaotalk',
				icon: {
					variant: 'BrandKakaoTalk',
					alt: 'kakaotalk',
				},
			},
			{
				href: 'https://twitter.com/ManCityKOR',
				title: 'x',
				icon: {
					variant: 'BrandX',
					alt: 'x',
				},
			},
		],
	},
	{
		href: 'https://www.mancitychina.com',
		lang: 'cn',
		title: 'Simplified Chinese',
		label: '简体中文',
		socials: [
			{
				href: 'https://v.douyin.com/qv82LXyWCBU/',
				title: 'Douyin',
				icon: {
					variant: 'BrandTikTok',
					alt: 'Douyin',
				},
			},
			{
				href: 'https://b23.tv/zcvowtp',
				title: 'Bilibili',
				icon: {
					variant: 'BrandBilibili',
					alt: 'Bilibili',
				},
			},
			{
				href: 'https://www.xiaohongshu.com/user/profile/642a820a0000000011021af8',
				title: 'Red',
				icon: {
					variant: 'BrandRed',
					alt: 'Red',
				},
			},
			{
				href: 'http://www.weibo.com/mcfcofficial',
				title: 'sina weibo',
				icon: {
					variant: 'BrandWeibo',
					alt: 'sina weibo',
				},
			},
		],
	},
	{
		href: 'https://www.mancity.com',
		lang: 'en',
		title: 'English',
		label: 'English',
		socials: [
			{
				href: 'https://www.facebook.com/mancity',
				title: 'facebook',
				icon: {
					variant: 'BrandFacebook',
					alt: 'facebook',
				},
			},
			{
				href: 'https://twitter.com/ManCity',
				title: 'x',
				icon: {
					variant: 'BrandX',
					alt: 'x',
				},
			},
		],
	},
	{
		href: 'https://pt.mancity.com',
		lang: 'pt',
		title: 'Portuguese',
		label: 'Português',
		socials: [
			{
				href: 'https://twitter.com/ManCityPT',
				title: 'x',
				icon: {
					variant: 'BrandX',
					alt: 'x',
				},
			},
		],
	},
	{
		href: 'https://fr.mancity.com',
		lang: 'fr',
		title: 'French',
		label: 'Français',
		socials: [
			{
				href: 'https://twitter.com/ManCityFRA',
				title: 'x',
				icon: {
					variant: 'BrandX',
					alt: 'x',
				},
			},
		],
	},
	{
		href: 'https://es.mancity.com',
		lang: 'es',
		title: 'Spanish',
		label: 'Español',
		socials: [
			{
				href: 'https://twitter.com/ManCityES',
				title: 'x',
				icon: {
					variant: 'BrandX',
					alt: 'x',
				},
			},
		],
	},
	{
		href: 'https://id.mancity.com',
		lang: 'id',
		title: 'Indonesian',
		label: 'Bahasa Indonesia',
		socials: [
			{
				href: 'https://twitter.com/ManCityIndo',
				title: 'x',
				icon: {
					variant: 'BrandX',
					alt: 'x',
				},
			},
		],
	},
	{
		href: 'https://th.mancity.com',
		lang: 'th',
		title: 'Thai',
		label: 'ภาษาไทย',
		socials: [
			{
				href: 'https://twitter.com/ManCityTH',
				title: 'x',
				icon: {
					variant: 'BrandX',
					alt: 'x',
				},
			},
		],
	},
	{
		href: '',
		lang: 'ja',
		title: 'Japanese',
		label: '日本語',
		socials: [
			{
				href: 'https://twitter.com/ManCityJP',
				title: 'x',
				icon: {
					variant: 'BrandX',
					alt: 'x',
				},
			},
		],
	},
];
